import {PageableModel} from "../../common/models/table";
import {AxiosResponse} from "axios";
import {Api, apiUrls} from "../../helpers/api";
import {ReportFileFormat} from "../models/reportFileFormatEnum";
import {DownloadService} from "../../common/services/downloadService";
import {DangerousGoodsRegisterModel, DangerousGoodsRegisterFilters} from "../models/dangerousGoodsRegister";
import http from "../../common/services/httpService";

export class DangerousGoodsRegisterService {
    private static baseUrl = apiUrls.reports.dangerousGoodsRegister;

    public static async generateReport(filters: DangerousGoodsRegisterFilters): Promise<AxiosResponse<PageableModel<DangerousGoodsRegisterModel>>> {
        const url = Api.getUrl(this.baseUrl);

        return await http.get<PageableModel<DangerousGoodsRegisterModel>>(
            `${Api.addParams(url, this.getParams(filters))}`
        );
    }

    public static async download(filters: DangerousGoodsRegisterFilters, fileFormat: ReportFileFormat): Promise<AxiosResponse> {
        const mediaType = fileFormat === ReportFileFormat.xls ? "application/xls" : "application/csv";

        return DownloadService.download(this.baseUrl, mediaType, this.getParams(filters));
    }

    private static getParams(filters: DangerousGoodsRegisterFilters) {
        return `arrivalFerryFrom=${filters.arrivalFerryFrom}&arrivalFerryTo=${filters.arrivalFerryTo}` +
            `&departureFerryFrom=${filters.departureFerryFrom}&departureFerryTo=${filters.departureFerryTo}` +
            `&ferryEntityId=${filters.ferryEntityId}&shipownerEntityId=${filters.shipownerEntityId}` +
            `&voyageNo=${filters.voyageNo}&unCodeId=${filters.unCodeId}&packingId=${filters.packingId}`;
    }
}
